// extracted by mini-css-extract-plugin
export default {"orderHeader":"Coupons_orderHeader__n462U","button":"Coupons_button__z5Xd1","productsContainer":"Coupons_productsContainer__zSLH+"};